import React from "react";
import { styled } from "styled-components";
import { mediaQueries } from "../../../styles";
import { rem } from "../../../utils";
const StyledFooterSection = styled.div `
  flex: 1;
  margin-top: ${rem(40)};
  ${mediaQueries.up("small") `
    flex-basis: calc(50% - ${rem(20 * 2)});
    flex-grow: 0;
  `}
  ${mediaQueries.up("medium") `
    flex-basis: calc(33% - ${rem(20 * 3)});
    flex-grow: 0;
  `}

  *:first-child {
    margin-top: 0;
  }
`;
export const FooterSection = ({ children }) => (React.createElement(StyledFooterSection, null, children));
export default FooterSection;
//# sourceMappingURL=index.js.map